import React, { useState, useEffect } from "react";
import Coupon from "./Coupon";
import { useParams } from "react-router-dom";
import { sendGACouponEvent } from "src/methods/ga";

import { getStores } from "src/actions/stores";
import { useActions } from "src/hooks/useActions";
import { useAuth } from "src/providers/Auth";
import { useToast } from "src/providers/Toast";
import { postCoupon, getCoupon } from "src/actions/coupon";
import Loading from "src/components/Loading";
import { getUtm } from "src/utils/method";
import { baseRoute } from "src/config";

const CouponPage = (props) => {
  const { couponId } = useParams();
  const {
    auth: { userId },
  } = useAuth();
  const { danger, success } = useToast();
  const qs = window.location.search;

  const [actionPostCoupon, actionGetCoupon, actionGetStores] = useActions([
    postCoupon,
    getCoupon,
    getStores,
  ]);

  const [invalidRedeemCode, setInvalidRedeemCode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const submitPostCoupon = async ({ redeemCode, couponId }) => {
    setInvalidRedeemCode(false);
    setIsLoading(true);
    const utm = getUtm();
    const res =
      (await actionPostCoupon({ redeemCode, couponId, userId, utm })) || {};

    if (!res || res.status !== 200) {
      setInvalidRedeemCode(true);
    } else {
      sendGACouponEvent(userId, couponId, `/coupon/${couponId}`);
      success("兌換成功");
      setTimeout(() => {
        window.location.href = `${baseRoute}/couponList` + qs;
      }, 1000);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      await Promise.all([
        actionGetCoupon({ couponId, userId }),
        actionGetStores({ userId }),
      ]);
      setIsLoading(false);
    }
    if (userId) fetchData();
  }, [userId]);

  return (
    <>
      {isLoading && <Loading />}
      <Coupon
        submitPostCoupon={submitPostCoupon}
        invalidRedeemCode={invalidRedeemCode}
      />
    </>
  );
};

export default CouponPage;
